import React from 'react';

const NotFoundPage = () => (
  <div>
    <h1
      style={{
        color: 'var(--offwhite)',
        textAlign: 'center',
        textShadow: '1px 2px 1px var(--red)',
        padding: '10px',
      }}
    >
      404: Page Not Found
    </h1>
  </div>
);

export default NotFoundPage;
